import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import ModalDialog from 'src/components/ModalDialog';
import { useModal } from 'src/hooks';
import { useUserRoles } from 'src/auth';
import DataTableActionsButton from 'src/components/DataTable/components/DataTableActionsButton';
import EditOutlined from '@mui/icons-material/EditOutlined';
import { SolutionSiteEdgeServiceItem } from '../../types';
import SolutionSiteEdgeServiceUrlEditModal from './SolutionSiteServiceUrlEditModal';

type Props = {
  siteId: string;
  siteName: string;
  title: string;
  item: SolutionSiteEdgeServiceItem;
  open: boolean;
  onClose: () => void;
  edgeServiceUrl?: string;
  setServiceUrl?: any;
};

function SolutionSiteServiceUrlViewModal({
  siteId,
  siteName,
  item,
  edgeServiceUrl,
  setServiceUrl,
  open,
  onClose,
}: Props) {
  const [edgeServicesUrlDialog, showEdgeServicesUrlDialog] = useModal(
    SolutionSiteEdgeServiceUrlEditModal,
    {
      siteId,
      siteName,
      item,
      setServiceUrl,
    }
  );
  const { isPlatformOwner, isPlatformEngineer, isSolutionOwner } =
    useUserRoles();
  const isValidUser = isPlatformOwner || isPlatformEngineer || isSolutionOwner;

  return (
    <ModalDialog
      open={open}
      maxWidth="sm"
      fullWidth
      title={`NanoMQ Service URL : ${siteName} `}
      titleStyle={{
        fontSize: '18px',
        fontFamily: 'Stolzl',
        fontWeight: 500,
      }}
      onClose={onClose}
      cancelBtnText="Close"
      showConfirmBtn={false}
    >
      <DataTableActionsButton
        data-testid="solution-sites-item-edit-action"
        icon={EditOutlined}
        title="Edit"
        sx={{ float: 'right', position: 'sticky' }}
        onClick={showEdgeServicesUrlDialog}
        disabled={!isValidUser}
      />
      <Box display="flex" justifyContent="space-between" alignContent="center">
        <Typography fontWeight={500} sx={{ paddingRight: '20px' }}>
          {' '}
          URL
        </Typography>
        <Box sx={{ wordBreak: 'break-all', paddingRight: '20px' }}>
          {edgeServiceUrl}
        </Box>
      </Box>
      {edgeServicesUrlDialog}
    </ModalDialog>
  );
}

export default SolutionSiteServiceUrlViewModal;
